import { OnDatalayerProps } from '../shared/HOCs/withGTM.interface';

export const DOWNLOAD_EVENT_NAME = 'gtm:pricelist:download';

export const onDatalayerDownloadEvent = ({ target }: OnDatalayerProps) => {
  const { position, linkText, fileName, fileExtension } = target;

  if (!target) {
    return undefined;
  }

  return {
    event: 'trackEvent-priceListTracking',
    event_name: 'price_list_download',
    eventCategory: 'engagement',
    eventAction: 'price_list_download',
    eventLabel: fileName,
    position,
    link_text: linkText,
    file_name: fileName,
    file_extension: fileExtension,
  };
};
